// External dependencies
import dayjs from "dayjs";
import "dayjs/locale/fr";
import duration from "dayjs/plugin/duration";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import localizedFormat from "dayjs/plugin/localizedFormat";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { createRoot } from "react-dom/client";

import "@EspaceParkQC/sdk-react/theme.css";
import "./assets/index.css";

// Internal dependencies
import { initializeAppConfig } from "@/config/app-config";
import i18next from "@/i18n";
import Root from "@/routes/root";

// Configure dayjs
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(duration);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(localizedFormat);

// Set dayjs locale based on i18n language
const setDayjsLocale = (language: string) => {
  if (language === "fr") {
    dayjs.locale("fr");
  } else {
    dayjs.locale("en");
  }
};

// Initialize dayjs locale
setDayjsLocale(i18next.language || "en");

// Update dayjs locale when i18n language changes
i18next.on("languageChanged", (language) => {
  setDayjsLocale(language);
});

initializeAppConfig();

// Initialize app
const container = document.getElementById("root");
if (!container) throw new Error("Failed to find root element");
const root = createRoot(container);
root.render(<Root />);

